function changeRatio(xLimit, yLimit, xValue) {
  return Math.floor((xValue * yLimit) / xLimit);
}

export default changeRatio;
